<template>
  <div>
    <Topnav />
    <div class="content">
      <div class="jumbotron text-center">
        <h2>Login with Telegram</h2>
        <hr class="bg-dark"/>
        <vue-telegram-login
          mode="callback"
          telegram-login="chatbotcreatorbot"
          requestAccess="write"
          @callback="onLogin"
        />
        <div>
          <div class="alert alert-info" v-if="tgAccessible == false">
            <strong>Note: </strong>Your network provider has blocked Telegram links, Unable to load Telegram
            Login widget. But don't worry you can still login to our website with our own Telegram ChatBot.
            Try clicking below button, if it doesn't work. Go to Telegram App and search for @Chatbotcreatorbot 
            and click login.
          </div>
          <h4>or</h4>
          <form action="https://t.me/Chatbotcreatorbot" target="blank">
            <input type="submit" class="btn btn-outline-success" value="Login with Bot" />
          </form>
        </div>
      </div>

      <Loading :active.sync="isLoading" color="green"></Loading>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import axios from "axios";
import { vueTelegramLogin } from "vue-telegram-login";
import ApiService from "@/services/ApiService";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Topnav from "@/components/Topnav.vue";

export default {
  name: "login",
  props: {
    to: Object,
  },
  components: {
    vueTelegramLogin,
    Loading,
    Topnav,
  },
  data: function () {
    return {
      isLoading: false,
      tgAccessible: true,
    };
  },
  methods: {
    onLogin: function (user) {
      this.isLoading = true;
      ApiService.getUser(user)
        .then(
          function () {
            this.$store.dispatch("login", user);
            if (this.to) {
              if (this.to.path !== "/login") {
                this.$router.push({ path: this.to.path });
              }
            } else {
              this.$router.push({ path: "/" });
            }
          }.bind(this)
        )
        .catch(
          function (response) {
            if (response.status_code == 200) {
              ApiService.createUser(user)
                .then(
                  function () {
                    console.log("Created User");
                    this.$store.dispatch("login", user);
                    if (this.to) {
                      if (this.to.path !== "/login"){
                        this.$router.push({ path: this.to.path });
                      }
                    } else {
                      this.$router.push({ path: "/" });
                    }
                  }.bind(this)
                )
                .catch(
                  function (response) {
                    console.log(response.description);
                    this.$dialog.alert(response.description);
                  }.bind(this)
                );
            } else {
              console.log(response.description);
              this.$dialog.alert("Login failed");
              this.isLoading = false;
            }
          }.bind(this)
        )
        .finally(
          function () {
            this.isLoading = false;
          }.bind(this)
        );
    },
    checkConnection: function () {
      let url = "https://cors-anywhere.herokuapp.com/https://telegram.org/js/telegram-widget.js?10"
      axios
        .get(
          url
        )
        .then(
          function () {
            this.tgAccessible = true;
          }.bind(this)
        )
        .catch(
          function () {
            this.tgAccessible = false;
          }.bind(this)
        );
    },
  },

  mounted: function () {
    let user = this.$route.query;
    if ("hash" in user){
      this.onLogin(user);
    }
    //this.checkConnection();
  },
};
</script>
